import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import _camelCase from "lodash/camelCase";
import _upperFirst from "lodash/upperFirst";
import _capitalize from "lodash/capitalize";
var _excluded = ["accessibilityLabel", "children", "fullwidth", "iconPosition", "iconColor", "iconSize", "onPress", "selected", "styleType", "childStyles", "url", "className", "flexEnd", "variant", "inTransition", "childClassName", "attributes"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { useState } from 'react';
import classnames from 'classnames';
import { Button } from "../Button/Button";
import Colors from "../../Color/Colors";
import { Icon } from "../../Icon/Icon/Icon";
import styles from "./ToggleButton.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ToggleButton = function ToggleButton(_ref) {
  var _ref$accessibilityLab = _ref.accessibilityLabel,
    accessibilityLabel = _ref$accessibilityLab === void 0 ? '' : _ref$accessibilityLab,
    children = _ref.children,
    _ref$fullwidth = _ref.fullwidth,
    fullwidth = _ref$fullwidth === void 0 ? false : _ref$fullwidth,
    _ref$iconPosition = _ref.iconPosition,
    iconPosition = _ref$iconPosition === void 0 ? 'left' : _ref$iconPosition,
    _ref$iconColor = _ref.iconColor,
    iconColor = _ref$iconColor === void 0 ? '' : _ref$iconColor,
    _ref$iconSize = _ref.iconSize,
    iconSize = _ref$iconSize === void 0 ? '20px' : _ref$iconSize,
    onPress = _ref.onPress,
    _ref$selected = _ref.selected,
    selected = _ref$selected === void 0 ? false : _ref$selected,
    _ref$styleType = _ref.styleType,
    styleType = _ref$styleType === void 0 ? 'primary' : _ref$styleType,
    childStyles = _ref.childStyles,
    _ref$url = _ref.url,
    url = _ref$url === void 0 ? '' : _ref$url,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$flexEnd = _ref.flexEnd,
    flexEnd = _ref$flexEnd === void 0 ? false : _ref$flexEnd,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'default' : _ref$variant,
    _ref$inTransition = _ref.inTransition,
    inTransition = _ref$inTransition === void 0 ? false : _ref$inTransition,
    _ref$childClassName = _ref.childClassName,
    childClassName = _ref$childClassName === void 0 ? '' : _ref$childClassName,
    _ref$attributes = _ref.attributes,
    attributes = _ref$attributes === void 0 ? {} : _ref$attributes,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(selected),
    _useState2 = _slicedToArray(_useState, 2),
    iconRotation = _useState2[0],
    setIconRotation = _useState2[1];
  var handlePress = function handlePress() {
    setIconRotation(!iconRotation);
    onPress && onPress();
  };
  var renderButtonContent = function renderButtonContent(addVariant) {
    var icon;

    // Set color based on style type.
    var iconColorCalculated = iconColor || Colors.colorWW110;
    if (styleType === 'tertiary') {
      icon = 'plus';
    } else if (styleType === 'quaternary') {
      icon = 'minus';
    } else {
      icon = 'arrow-down';
    }
    var animation = icon === 'arrow-down' ? 'Animation' : 'AnimationAlt';

    // Check for childStyles
    var textStyle = childStyles ? childStyles : {};
    var variantClass = _capitalize(variant).replace('-', '');
    return /*#__PURE__*/_jsx("span", {
      className: classnames(styles.toggleButton, {
        [styles["toggleButton".concat(variantClass)]]: addVariant,
        [styles["toggleButton".concat(variantClass, "Opened")]]: addVariant && iconRotation && variant === 'accordion'
      }, textStyle, {
        [styles.flexEnd]: flexEnd
      }),
      "data-e2e-name": "toggle_button",
      style: flexEnd && styleType === 'primary--with-link' ? {
        flexGrow: 0
      } : {},
      children: /*#__PURE__*/_jsxs("div", {
        className: classnames(styles.toggleButtonChildWrapper, childClassName),
        children: [!url && children, /*#__PURE__*/_jsx("span", {
          className: classnames(styles.toggleButtonIconWrapper, {
            [styles.flexEndIconWrapper]: flexEnd
          }),
          children: /*#__PURE__*/_jsx("span", {
            className: classnames(styles["toggleButtonIcon".concat(animation)], iconRotation && styles["toggleButtonIcon".concat(animation, "Inverse")]),
            children: /*#__PURE__*/_jsx(Icon, {
              width: iconSize,
              height: iconSize,
              type: icon,
              fill: iconColorCalculated
            })
          })
        })]
      })
    });
  };
  var addVariant = variant !== 'default';
  var iconPositionClass = _capitalize(iconPosition);
  var variantClass = _capitalize(variant);
  var styleTypeClass = _upperFirst(_camelCase(styleType));
  return /*#__PURE__*/_jsx("div", {
    className: classnames(styles.toggleButtonWrapper, styleType !== 'default' && styles["toggleButton".concat(styleTypeClass)], styles["toggleButtonIcon".concat(iconPositionClass)], fullwidth && styles.toggleButtonFullWidth, {
      [styles["toggleButtonWrapper".concat(variantClass)]]: addVariant
    }),
    "data-e2e-name": "toggle_button_wrapper",
    children: /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({
      onClick: handlePress,
      type: "banner-trigger",
      className: classnames(styles.toggleButtonButton, className, {
        [styles.flexEnd]: flexEnd,
        [styles["toggleButtonButton".concat(variantClass)]]: addVariant
      }),
      accessibilityLabel: accessibilityLabel,
      attributes: attributes
    }, otherProps), {}, {
      children: renderButtonContent(addVariant)
    }))
  });
};